var map = {
	"./img_1.jpg": 81242,
	"./img_2.jpg": 9904,
	"./img_3.jpg": 1217,
	"./img_4.jpg": 43314,
	"./img_5.jpg": 49044,
	"./img_6.jpg": 71992,
	"./img_7.jpg": 86029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63216;